import React from 'react';
import {PropTypes} from 'prop-types';
import {Link} from '../../shared/link';
import {MakeApiCall, WriteConsoleErrors, ReplaceUrl} from '../../shared/utils';
import {ErrorsBlockComponent} from '../../shared/errorsBlockComponent';
import {RefreshButtonComponent} from '../../shared/refreshButtonComponent';
import {AccountComponent} from '../AccountsListComponent/account';
import {InfoItem} from '../AccountInfo/infoitem';
import {DateTimeItem} from '../AccountInfo/datetimeitem';
import {UrlBuilder} from '../../app.defs';
import {PageHeader} from '../../shared/PageHeader';

const MAILINFO_ACTION = {
    NONE: 0,
    LOADING: 1,
}

export class MailInfoComponent extends React.Component {
    constructor(props, ...others) {
        super(props, ...others);
        this.state = {
            mailId: props.mailId,
            isLoaded: false,
            action: MAILINFO_ACTION.NONE,
            isLoading: false,
            errors: null,
            mailInfo: null,
            requestId: 0
        }

        this.doLoad = this.doLoad.bind(this);
        this.goToMailId = this.goToMailId.bind(this);
    }

    componentDidMount() {
        const self = this;

        self._isMounted = true;
        self.doLoad();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    doLoad() {
        const self = this;

        if (!self._isMounted) {
            return;
        }

        const requestId = self.state.requestId + 1;

        const data = {MailId: self.state.mailId, ListSource: self.props.listSource};

        new Promise(resolve => {
            self.setState({action: MAILINFO_ACTION.LOADING, errors: null, requestId: requestId}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return MakeApiCall(
                    $.get(
                        {
                            url: '/api/admin/getMailInfo',
                            data: data,
                            dataType: 'json',
                            cache: false
                        }
                    ),
                    false,
                    () => !self._isMounted || (self.state.requestId != requestId)
                )
            }
        })
        .then(response => {
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({
                    action: MAILINFO_ACTION.NONE,
                    isLoaded: true,
                    mailInfo: response,
                });
            }
        })
        .catch(errors => {
            WriteConsoleErrors(errors, true, false);
            if (self._isMounted && (self.state.requestId == requestId)) {
                self.setState({action: MAILINFO_ACTION.NONE, errors: errors})
            }
        });
    }

    goToMailId(mailId) {
        const self = this;

        if (self._isMounted) {
            ReplaceUrl(UrlBuilder.MailInfo({MailId: mailId, ListSource: self.props.listSource}));
    
            self.setState({mailId: mailId}, self.doLoad);
        }
    }

    render() {
        const self = this;
        const {mailId, mailInfo, action, isLoaded, errors} = self.state;
        const {timeZoneId} = self.props;

        const isDisabled = !isLoaded || (action != MAILINFO_ACTION.NONE);

        const buttonPrev = Boolean(mailInfo) &&
            <Link 
                key="buttonPrev"
                className="btn btn-outline-secondary btn-sm newstyle" 
                disabled={isDisabled || !Boolean(mailInfo.PrevId)} 
                to={() => self.goToMailId(mailInfo.PrevId)}
            >
                Prev
            </Link>
        
        const buttonNext = Boolean(mailInfo) &&
            <Link 
                key="buttonNest"
                className="btn btn-outline-secondary btn-sm newstyle" 
                disabled={isDisabled || !Boolean(mailInfo.NextId)} 
                to={() => self.goToMailId(mailInfo.NextId)}
            >
                Next
            </Link>

        let senderParams = '';
        if (isLoaded && Boolean(mailInfo.SenderParams)) {
            try {
                senderParams = JSON.stringify(JSON.parse(mailInfo.SenderParams), null, 4);
            }
            catch (error) 
            {
                senderParams = mailInfo.SenderParams;
            }
        }

        let messageData = '';
        if (isLoaded && Boolean(mailInfo.MessageData)) {
            try {
                messageData = JSON.stringify(JSON.parse(mailInfo.MessageData), null, 4);
            }
            catch (error) 
            {
                messageData = mailInfo.MessageData;
            }
        }

        let deliveryInfo = '';
        if (isLoaded && Boolean(mailInfo.DeliveryInfo) && Boolean(mailInfo.DeliveryInfo.DeliveryInfo)) {
            try {
                deliveryInfo = JSON.stringify(JSON.parse(mailInfo.DeliveryInfo.DeliveryInfo), null, 4);
            }
            catch (error) 
            {
                deliveryInfo = mailInfo.DeliveryInfo.DeliveryInfo;
            }
        }

        let bounceInfo = '';
        if (isLoaded && Boolean(mailInfo.DeliveryInfo) && Boolean(mailInfo.DeliveryInfo.BounceInfo)) {
            try {
                bounceInfo = JSON.stringify(JSON.parse(mailInfo.DeliveryInfo.BounceInfo), null, 4);
            }
            catch (error) 
            {
                bounceInfo = mailInfo.DeliveryInfo.BounceInfo;
            }
        }

        return (
            <div>
                <PageHeader
                    fixed
                    captionTruncate
                    notWrappedMaxHeight={75}
                    caption={
                        <h2 className="text-truncate">                                    
                            <span className="mr-2">Mail #{mailId}</span>
                            <RefreshButtonComponent 
                                disabled={action == MAILINFO_ACTION.LOADING} 
                                animated={action == MAILINFO_ACTION.LOADING} 
                                onClick={self.doLoad} 
                                className="fs-085"
                            />
                        </h2>
                    }
                    buttons={[<div key="buttonGroup" className="btn-group">{[buttonPrev, buttonNext].filter(Boolean)}</div>]}
                />
                <ErrorsBlockComponent errors={errors} />
                {isLoaded &&
                    <div>
                        {Boolean(mailInfo.AccountId) &&
                            <InfoItem caption="Account" content={<AccountComponent id={mailInfo.AccountId} name={mailInfo.AccountName} disabled={isDisabled} showId showLoginAs linkToInfo />} />
                        }
                        <InfoItem caption="Mail address" content={mailInfo.MailAddress} />
                        <InfoItem caption="Mail type" content={mailInfo.MailTypeName} />
                        <InfoItem caption="Sent at" content={<DateTimeItem utcDate={mailInfo.TimeStamp} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                        {mailInfo.IsSuccess &&
                            <InfoItem caption="Sending result" content={<span className="text-success">Success</span>} />
                        }
                        {!mailInfo.IsSuccess &&
                            <>
                                <InfoItem caption="Sending result" content={<span className="text-danger">Failed</span>} />
                                {Boolean(mailInfo.ErrorMessage) &&
                                    <InfoItem vertical caption={<span className="text-danger">Error message</span>} content={<textarea className="form-control compact text-body bg-white" rows={2} readOnly value={mailInfo.ErrorMessage} />} />
                                }
                            </>
                        }
                        <InfoItem caption="Unique Id" content={mailInfo.UniqueId} />
                        <InfoItem caption="Extended Id" content={mailInfo.ExtendedId} />
                        <InfoItem vertical caption="Sender parameters" content={<textarea className="form-control compact text-body bg-white" rows={4} readOnly value={senderParams} />} />
                        <InfoItem vertical caption="Message data" content={<textarea className="form-control compact text-body bg-white" rows={4} readOnly value={messageData} />} />
                        {Boolean(mailInfo.DeliveryInfo) &&
                            <>
                                <InfoItem caption="Delivered at" content={<DateTimeItem utcDate={mailInfo.DeliveryInfo.TimeStamp} timeZoneId={timeZoneId} format="L LTS (z)" />} />
                                <InfoItem caption="SMTP message Id" content={mailInfo.DeliveryInfo.SmtpMessageId} />
                                {Boolean(deliveryInfo) &&
                                    <InfoItem vertical caption="Delivery details" content={<textarea className="form-control compact text-body bg-white" rows={4} readOnly value={deliveryInfo} />} />
                                }
                                {Boolean(bounceInfo) &&
                                    <InfoItem vertical caption="Bounce details" content={<textarea className="form-control compact text-body bg-white" rows={4} readOnly value={bounceInfo} />} />
                                }
                            </>
                        }
                   </div>
                }
            </div>
        )
    }
}
MailInfoComponent.propTypes = {
    mailId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    timeZoneId: PropTypes.string.isRequired,
    listSource: PropTypes.string,
}